// This module is used for access to ENV variables during runtime
export default {
    MOBX_LOG_ENABLED: MOBX_LOG_ENABLED,
    CLIENT_ID: CLIENT_ID,
    REDIRECT_URI: REDIRECT_URI,
    NETBOX_CLIENT_ID: NETBOX_CLIENT_ID,
    NETBOX_REDIRECT_URI: NETBOX_REDIRECT_URI,
    IS_DEV: IS_DEV,
    FEATURE_PLOT: FEATURE_PLOT,
    PLAYER_JS_URL: null,
    PLAYER_CSS_URL: null,
    CARBON_VIEWER_URL: CARBON_VIEWER_URL,
    SENTRY_DSN: SENTRY_DSN,
    APP_VERSION: APP_VERSION,
};
